// GroupItem.tsx  (диспетчер)
import React from "react";
import { GroupedProduct } from "../../../../common/types/types";
import { ItemVariant } from "../../../../common/types/enums";
import { GroupItemDetailed } from "./groupItemDetailed/GroupItemDetailed";
import { GroupItemMinimal } from "./groupItemMinimal/GroupItemMinimal";
import { GroupItemFlat } from "./groupItemFlat/GroupItemFlat";
import { GroupItemWide } from "./groupItemWide/GroupItemWide";

type Props = {
  group: GroupedProduct;
  onPress: () => void;
  getCategoryName: (id: number) => string | undefined;
  variant?: ItemVariant;
  isAuth?: boolean;
  usingStock?: boolean;
};

export default function GroupItem({
  group,
  onPress,
  getCategoryName,
  variant = ItemVariant.DETAILED,
  isAuth,
  usingStock,
}: Props) {
  const isPrerender =
    typeof window !== "undefined" &&
    window.location.search.includes("__prerender=1");

  if (isPrerender) {
    return (
      <GroupItemDetailed
        group={group}
        onPress={onPress}
        getCategoryName={getCategoryName}
        isAuth={isAuth}
        usingStock={usingStock}
      />
    );
  }

  switch (variant) {
    case ItemVariant.MINIMAL:
      return (
        <GroupItemMinimal
          group={group}
          onPress={onPress}
          getCategoryName={getCategoryName}
          isAuth={isAuth}
          usingStock={usingStock}
        />
      );

    case ItemVariant.FLAT:
      return (
        <GroupItemFlat
          group={group}
          onPress={onPress}
          getCategoryName={getCategoryName}
          isAuth={isAuth}
          usingStock={usingStock}
        />
      );

    case ItemVariant.WIDE:
      return (
        <GroupItemWide
          group={group}
          onPress={onPress}
          getCategoryName={getCategoryName}
          isAuth={isAuth}
          usingStock={usingStock}
        />
      );

    case ItemVariant.DETAILED:
    default:
      return (
        <GroupItemDetailed
          group={group}
          onPress={onPress}
          getCategoryName={getCategoryName}
          isAuth={isAuth}
          usingStock={usingStock}
        />
      );
  }
}
